import "./ConciergeIcon.css";

// Flat, vector Concierge AI mark: StayGuide "S" swoosh + AI sparkle.
// Transparent background, crisp from 24px up. No glow / 3D.
export function ConciergeIcon({ className = "w-6 h-6", animated = false }) {
  return (
    <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path d="M33 15.5c-3.6-3-13-3.2-13 2.6 0 5.2 11.2 3.9 11.2 9.2 0 6-9.4 6-13.2 2.9"
        stroke="#14306B" strokeWidth="5.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M33 15.5c-3.6-3-13-3.2-13 2.6 0 5.2 11.2 3.9 11.2 9.2 0 6-9.4 6-13.2 2.9"
        stroke="#4F86E0" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" />
      <g className={animated ? "sg-sparkle" : ""}>
        <path d="M38 6.5c.8 3.6 1.8 4.6 5.4 5.4-3.6.8-4.6 1.8-5.4 5.4-.8-3.6-1.8-4.6-5.4-5.4 3.6-.8 4.6-1.8 5.4-5.4Z" fill="#4F86E0" />
        <path d="M44.2 16.5c.35 1.6.85 2.1 2.45 2.45-1.6.35-2.1.85-2.45 2.45-.35-1.6-.85-2.1-2.45-2.45 1.6-.35 2.1-.85 2.45-2.45Z" fill="#8EB6EF" />
      </g>
    </svg>
  );
}
